import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {checkPermissions} from '../../utils/permissions';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {getSortClass,converDateToLocal,convertDecimalToHHMM} from '../../utils/commonUtilities';

import {URL_IMG} from '../../configs/urlConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, PAGENUMROWS_AFFILIATE,PAGING_END_INDEX,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, SEARCH_TEXT_COUNT,ROUTE_AFFILIATE_CLIENT_PROFILE,SHIFT_STATUS,ROUTE_AFFILIATE_SCHEDULE_SHIFT, SHIFT_CANCEL_ERROR_CODE} from '../../configs/staticConfigs';
import{ MSG_NOT_FOUND,MSG_SHIFT_DELETE,MSG_SHIFT_UPDATE,MSG_SHIFT_CANCELLED, MSG_SHIFT_CANCEL_ERROR, MSG_SHIFT_UPDATE_ERROR,MSG_SHIFT_UPDATE_PAST_TIME_ERROR,MSG_SHIFT_DELETE_ERROR,MSG_RESEND_QUOTE_FOR_CLIENT_APPROVAL,MSG_SHIFT_TIME_CHANGE_ACCEPT_SUCCESS} from '../../configs/msgConfigs';
import { LBL_LIST_ALL,LBL_ACTION_NEEDED,LBL_APP_NAME, LBL_SHIFT,LBL_CLEAR_FILTERS,LBL_HOURS_SHORT, LBL_SLNUM, LBL_SHIFT_NAME, LBL_EVENT_TITLE, LBL_SHIFT_TIME, LBL_CREW_CHIEF_S, LBL_CLIENT, LBL_SHIFT_STATUS, LBL_TEAM_COUNT, LBL_SCHEDULE, LBL_EDIT, LBL_DELETE, LBL_CANCEL, LBL_FILTER, LBL_CONFIRM_DELETE_SHIFT, LBL_CONFIRM_CANCEL_SHIFT, LBL_QUOTES, LBL_EVENTS, LBL_REQUESTS_SEND, LBL_UNALLOCATED_SHIFT_TODAY_TOMORROW, LBL_UNALLOCATED_SHIFT, LBL_SHIFTS, LBL_ADD_NEW_CLIENT_CONTACT, LBL_CONFIRM_DELETE } from '../../configs/labelConfigs';

import { shiftListAction,quoteEventLocationListAction,shiftDeleteAction,sendShiftIdsForScheduleAction,shiftCancelAction, shiftPopupIdResetAction, eventPopupIdSetAction } from '../../actions/eventActions'; 
import { clearAction, menuActiveAction, fromDashboard, filterByAction, shiftTitle, serverTimeAction } from '../../actions/commonActions';
import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import * as types from '../../actions';


import {eventRouteRedirect,showShiftDeleteBtn,checkShiftNotCancelled,showShiftCancelBtn,showShiftScheduleBtn} from './eventStatusCheck';
import ClientContactAdd from '../client/tabContent/clientContactAdd'; 


import ModalWindow from '../commons/helpers/modalWindow';
import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import FilterShift from './filters/filterShift';
import ShiftDetailSlider from './shiftDetailSlider';
import ShiftAdd from './shiftAdd';
import { format } from 'date-fns';

class ShiftListComponent extends Component {

    constructor(props){
        super(props)

        this.state = {
            actionNeeded: true,
            hrefShiftId: this.props.match.params.id,
            hrefShiftIdUsed: 0,
            activePage:1,
            startIndex : 0, 
            endIndex : PAGING_END_INDEX,
            activeRowId:0,    
            perPageCount:PAGENUMROWS_AFFILIATE,
            //sortField:'start_datetime',
            sortField:'',
            sortOrder:'',  
            isFilterOn: false,
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true, 
            searchShift:'',                     
            eventDataForShift:{
                eventId:'',
                eventTitle: '',
                clientId:'',
                affiliateId:'',
                location:'',                
                venueName:"",
                streetOne:"",
                streetTwo:"",
                city:"",
                state:"",
                country:"",
                postcode:"",
                startDate:"",
                endDate:"",
            },
            profileId:'',
            shiftId:'',
            shiftTitle:'',
            isClientPage:false,
            shiftStatus:SHIFT_STATUS,
            activeShiftId: 0,
            activeShiftTitle: '',
            filterClicked: 0,
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            applyFilter: 0,
            filtersData: {},
            newClientContactAdded: 0,
            addContactClicked: 0,
            saveFormDataClicked: 0,
        }

        this.contactModal        = React.createRef(); 
        this.modalDelete         = React.createRef();
        this.modalShiftCancel    = React.createRef();
        this.shiftRef    = React.createRef();
    }
    
    openAddClientContact = (eventClientId) => {
        let addContactClicked = this.state.addContactClicked+1; 
        this.setState({addContactClicked:addContactClicked}, () => {
            this.contactModal.current.handleOpenModal(); 
            setTimeout(()=> {
                let contactModalPop = document.getElementById('contactModalPop');   
                if(contactModalPop) {
                    contactModalPop.style.width='650px';
                } 
            }, 500); 
        })
    }

    onSaveFormClientContactData = (e) => {
        let saveFormDataClicked = this.state.saveFormDataClicked+1;
        this.setState({saveFormDataClicked});
    } 
    
    onModalClientContactFormReset = () => {

    }

    refreshParent = () => {
        let newClientContactAdded = this.state.newClientContactAdded+1;
        this.setState({newClientContactAdded}, () => {
            this.contactModal.current.handleModelClose();
        });
    }

    onCloseToastPop = () =>{ // USED FOR POPUP clientContactAdd
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    setToasterStatePop = (isEnabled,message,isSucces,isAutoHide=true) => {
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToastPop();
            }, 3000);
        }    
    }

    onResetFiltersButton = () => {  
        let resetFilterClicked = this.state.resetFilterClicked+1;
        let applyFilterClicked = 0;
        let {filtersData} = this.state;
        filtersData['unallocatedShift']=false;
        this.setState({actionNeeded:false});
        //sortField:'start_datetime' -> sortOrder:''
        this.setState({resetFilterClicked,unallocatedShift:false,applyFilter:1,applyFilterClicked:applyFilterClicked,activePage:1, sortOrder:'', sortField:'',startIndex : 0, endIndex : PAGING_END_INDEX, filtersData:filtersData}, () => {
            this.props.serverTimeAction();
            if(this.state.isFilterOn) {
                document.getElementById("filterIcon").classList.add('active');   
            }
            else if(!this.state.isFilterOn) {
                document.getElementById("filterIcon").classList.remove('active');   
            }
        });
       
    }

    onApplyFilterButton = () => {
        let applyFilterClicked = this.state.applyFilterClicked+1;
        this.setState({applyFilterClicked:applyFilterClicked},()=>{
          this.props.serverTimeAction();
        }) 
        
    }

    applyFilters = (filtersData) => {
        // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
        let filterApplied = 0; 
        if(filtersData.filtersSelected > 0) filterApplied = 1; 
        let sortOrder = ''; 
        let sortField = ''; 
        //let sortField = 'start_datetime';
        //and comment the below line as well to make sort order empty for icon back to default 
        // if(filtersData.selectedStartDate!==0) sortField = 'start_datetime'; 
        if(this.props.unallocatedShifts){
          this.props.shiftTitle(LBL_UNALLOCATED_SHIFT_TODAY_TOMORROW);
          this.props.fromDashboard(false);
        }
        this.setState({activePage:1, sortOrder:sortOrder, sortField:sortField, searchShift:'', applyFilter:filterApplied, filtersData:filtersData}, () => {
            this.props.shiftListAction({pageSize:this.state.perPageCount,page:1,column:sortField,search:'',applyFilter:filterApplied,filtersData:filtersData}); 

        }); 
    }

    onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
        }else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }        
    }    

    onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
    }   

    
    editBtnClick = (shiftId) =>{    
        let {eventDataForShift} = this.state;
        let {shiftsList} = this.props;
        const selectedShift = shiftsList.filter(x => x.id ===Number(shiftId));
        let eventLocation = selectedShift[0].event_details.location_details.location;
        let clientId = selectedShift[0].event_details.client_profile;
        let affiliateId = selectedShift[0].event_details.affiliate_profile;
        let eventId = selectedShift[0].event;
        let startDate = selectedShift[0].start_datetime;       
        let endDate = selectedShift[0].end_datetime;

        eventDataForShift['eventId'] = eventId;
        eventDataForShift['eventTitle'] = 'New Title';
        eventDataForShift['clientId'] = clientId;
        eventDataForShift['affiliateId'] = affiliateId;
        eventDataForShift['location'] = eventLocation.id;
        eventDataForShift['venueName'] = eventLocation.venue;
        eventDataForShift['streetOne'] = eventLocation.street1;
        eventDataForShift['streetTwo'] = eventLocation.street2;
        eventDataForShift['city'] = eventLocation.city;
        eventDataForShift['state'] = eventLocation.state;
        eventDataForShift['country'] = eventLocation.country;
        eventDataForShift['postcode'] = eventLocation.postcode;
        eventDataForShift['startDate'] = startDate;
        eventDataForShift['endDate'] = endDate;
        
        this.setState({eventDataForShift}, () => this.shiftRef.current.openShiftModal(shiftId));
    }

    deleteBtnClick = (rowId,title) =>{
        this.setState({
            shiftId:rowId,
            shiftTitle:title          
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let shiftId = this.state.shiftId;
        this.props.shiftDeleteAction(shiftId);
        this.modalDelete.current.handleModelClose();                    
    }    

    openShiftCancelModal = (shiftId) =>{
        this.setState({
            shiftId:shiftId,
        }); 
        this.modalShiftCancel.current.handleOpenModal();
    }

    onCancelAction = () =>{
        let shiftId = this.state.shiftId;
        this.props.shiftCancelAction(shiftId);
        this.modalShiftCancel.current.handleModelClose();                    
    }
   
    onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      if(this.state.applyFilter > 0) {
        this.props.shiftListAction({pageSize:this.state.perPageCount,page:previousPage,column:this.state.sortOrder+this.state.sortField,applyFilter:1,filtersData:this.state.filtersData});
      }
      else {
        this.props.shiftListAction({pageSize:this.state.perPageCount,page:previousPage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift});
      }
      
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
    }

    onPageUp = (e) => {
    
      if(this.state.applyFilter > 0) {
        this.props.shiftListAction({pageSize:this.state.perPageCount,page:e.target.id,column:this.state.sortOrder+this.state.sortField,applyFilter:1,filtersData:this.state.filtersData});
      }
      else {
        this.props.shiftListAction({pageSize:this.state.perPageCount,page:e.target.id,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift});
      } 
  
      this.setState({
          activePage: Number(e.target.id)                   
      });
    }

    onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      if(this.state.applyFilter > 0) {
        this.props.shiftListAction({pageSize:this.state.perPageCount,page:nextPage,column:this.state.sortOrder+this.state.sortField,applyFilter:1,filtersData:this.state.filtersData});
      }
      else {
        this.props.shiftListAction({pageSize:this.state.perPageCount,page:nextPage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift});
      }
      
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
    }

    onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
          sOrder = (this.state.sortOrder==='-') ? '' : '-'; 
          if(this.state.applyFilter > 0) {
            this.props.shiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:sOrder+this.state.sortField,applyFilter:1,filtersData:this.state.filtersData});
          }
          else {
            this.props.shiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:sOrder+this.state.sortField,search:this.state.searchShift});
          }
          this.setState({ sortOrder:sOrder });            
      }else{
          this.setState({ sortField:sortKey });
          if(this.state.applyFilter > 0) {
            this.props.shiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+sortKey,applyFilter:1,filtersData:this.state.filtersData});
          }
          else {
            this.props.shiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+sortKey,search:this.state.searchShift});
          }
      }        
    }

    onModalFormReset = () =>{      
        this.setState({            
            shiftId:'',
            shiftTitle:''  
        }); 
    } 

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    // onShiftSummaryCloseToast = () =>{
    //     this.setState({shiftSummaryToastFlag:false,shiftSummaryToastMessage:'',shiftSummaryToastSuccess:false});
    // } 

    onSearchShift = (e)=>{
        let sVal = e.target.value; 
        this.setState({searchShift:sVal}, () => { 
            if(String(sVal).length >= 3 || String(sVal).length===0) {
              if(this.state.applyFilter > 0) { 
                this.props.shiftListAction({pageSize:this.state.perPageCount,page:1,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift,applyFilter:1,filtersData:this.state.filtersData});
              }else{
                this.props.shiftListAction({pageSize:this.state.perPageCount,page:1,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift});
              }
            }
        });
        
    }

    loadEventSchedule = (eventId,shiftDetails) => {
        
        if(shiftDetails) {
            // SKILLS NEED TO BE CONVERTED INTO OTHER FORMAT 
            // "shift_skills":[{"id":4286,"skill_id":1306,"skill_name":"General","required":2,"requested":0,"assigned":0,"rejected":0,"pending":2}]
            // "shift_skills":[{"id":4225,"skill":{"id":1306,"skill_name":"General","is_active":true,"index":1,"affiliate":210},"scheduled":false,"pending":12,"chiefs_pending":3,"count":12,"requested":1,"assigned":0,"rejected":0,"chiefs_required":3,"chiefs_requested":0,"chiefs_accepted":0,"chiefs_rejected":0},
            let allSkills = [];
            shiftDetails.shift_skills.forEach(item => {
                allSkills.push({id:item.id, skill:{id:item.skill_id,skill_name:item.skill_name}, pending:item.pending, requested:item.requested, assigned:item.assigned, rejected:item.rejected, chiefs_pending:item.chiefs_pending?item.chiefs_pending:0, chiefs_required:item.chiefs_required?item.chiefs_required:0, chiefs_requested:item.chiefs_requested?item.chiefs_requested:0, chiefs_accepted:item.chiefs_accepted?item.chiefs_accepted:0,chiefs_rejected:item.chiefs_rejected?item.chiefs_rejected:0 }); 
            })
            
            let shiftDet = {
                start_datetime:shiftDetails.start_datetime,
                end_datetime:shiftDetails.start_datetime,
                shift_skills:allSkills,
                id:shiftDetails.shift_id,
                chiefs_required:shiftDetails.chiefs_required,
                chiefs_pending:shiftDetails.chiefs_pending,
                status:shiftDetails.status,
                department:shiftDetails.department_name!==null?shiftDetails.department_name:'',
                resources:1,       
                pending:1     
            }            
            this.gotoSchedule('',eventId,shiftDet);
        }
        else {
            this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT+'/'+eventId);
        }
    }

    gotoSchedule = (e,eventId,shiftDetails)=>{ // schedule the selected shift
        let shiftItems = [];
        if(shiftDetails.pending>0 && shiftDetails.resources>0){
             shiftItems = [{
                start_datetime:shiftDetails.start_datetime,
                end_datetime:shiftDetails.start_datetime,
                skills:shiftDetails.shift_skills,
                shiftId:shiftDetails.id,
                chiefsRequired:shiftDetails.chiefs_required,
                chiefsPending:shiftDetails.chiefs_pending,
                isAllChecked:false,
                status:shiftDetails.status,
                department:shiftDetails.department!==null?shiftDetails.department:''              
            }];
        }
        this.props.sendShiftIdsForScheduleAction(shiftItems);
        this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT+'/'+eventId);
    }

    // THIS FUNCTION CALLED FROM shiftAdd.js WHEN SHIFT TIME CHANGE IS ACCEPTED
    scheduleShift = (eventId,shiftData,goToScheduleAfterTimeChangeAccept) => {
        if (eventId && shiftData && goToScheduleAfterTimeChangeAccept) {  
            let shiftDet = {
                start_datetime:shiftData.startDate,
                end_datetime:shiftData.endDate,
                shift_skills:{},
                id:shiftData.shiftId,
                chiefs_required:false,
                chiefs_pending:0,
                status:shiftData.shiftStatus,
                department:shiftData.department,
                resources:1,       
                pending:1     
            } 
            this.gotoSchedule('',eventId,shiftDet);
        }
    }

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 5000);
    }  

    showShiftDetail = (id, rowNum, shiftTitle) =>{
        //this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn }));
        this.setState({ activeShiftId:id, activeShiftRowNum:rowNum, activeShiftTitle:shiftTitle });
        if(this.state.isFilterOn){
            this.inputFilter.click();
        }
        document.getElementById("filterByMenu").classList.toggle('active');    
        let filterByMenu = document.getElementById('filterByMenu');  
        let quoteTab = document.getElementById('detailTab');
        let filterTab = document.getElementById('filterTab');
        quoteTab.style.display = 'block';    
        filterTab.style.display = 'none';
        filterByMenu.style.width='1100px';
        filterByMenu.style.right='0';
        this.props.shiftPopupIdResetAction(''); 
    }

    showEventPage = (eventId,eventRoute) => { 
        this.props.eventPopupIdSetAction(eventId); 
        if(eventRoute.includes(LBL_QUOTES.toLowerCase())) this.props.menuActiveAction(LBL_QUOTES); 
        else if(eventRoute.includes(LBL_EVENTS.toLowerCase())) this.props.menuActiveAction(LBL_EVENTS); 
        this.props.history.push(eventRoute); 
    }

    onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      document.getElementById("filterByMenu").classList.toggle('active');      
      document.getElementById("filterIcon").classList.toggle('active');   
      let filterByMenu = document.getElementById('filterByMenu');    
      let quoteTab = document.getElementById('detailTab');
      let filterTab = document.getElementById('filterTab');
        quoteTab.style.display = 'none';    
        filterTab.style.display = 'block';        
        if(this.state.isFilterOn){
            filterByMenu.style.width='550px';
            filterByMenu.style.right='-550px';
        }else{
            filterByMenu.style.width='550px';
            filterByMenu.style.right='0';
        }
        this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
    }

    closeDetailSlider=() =>{
        document.getElementById("filterByMenu").classList.remove('active'); //to close the slider
        let filterByMenu = document.getElementById('filterByMenu');
        let filterTab = document.getElementById('filterTab');
        let quoteTab = document.getElementById('detailTab');
        filterTab.style.display = 'block';
        quoteTab.style.display = 'none';  
        filterByMenu.style.width='450px';  
        filterByMenu.style.right='-1000px';
    }

    onSearchLocation = (query) =>{
        if(query.length>=SEARCH_TEXT_COUNT){
            this.props.quoteEventLocationListAction({pageSize:'',page:0,column:'-id',search:query});
        }           
    }   
    
    quoteOrInvoice = () =>{

    }
   
    setStateUpdate(numRows,totalPage,activity,errorData,status){
        let {hrefShiftId} = this.state;
        if(activity===types.SHIFT_DELETE_SUCCESS){
            if (numRows===1 && totalPage > 1){
                let page = this.state.activePage-1;  
                this.props.shiftListAction({pageSize:this.state.perPageCount,page:page,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift,applyFilter:1,filtersData:this.state.filtersData});
            }else{ 
                this.props.shiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift,applyFilter:1,filtersData:this.state.filtersData});
            }          
            this.setToasterState(true,MSG_SHIFT_DELETE,true); 
            this.closeDetailSlider();
        }else if(activity===types.SHIFT_DELETE_ERROR){
            if(status===405){
                if(errorData.hasOwnProperty('message')){
                    let errorMsg = errorData.message;
                    if(errorMsg==='crews_assigned'){                        
                        this.setToasterState(true,MSG_SHIFT_DELETE_ERROR,false);
                    }else{
                        this.setToasterState(true,errorMsg,false);
                    }
                }                
            }else{
                this.setToasterState(true,JSON.stringify(errorData),false);
            }
        }else if(activity===types.EVENT_SHIFT_UPDATE_SUCCESS){
            let msgStr = MSG_SHIFT_UPDATE;  
            // resend_quote_for_client_approval:true SEND FROM SERVER SIDE WHEN CONFIRMED QUOTE CHANGED TO ESTIMATE/REESTIMATE ONLY, IF THIS IS TRUE NOTIFY THE USER   
            if(this.props.shiftUpdateData && this.props.shiftUpdateData.resend_quote_for_client_approval && this.props.shiftUpdateData.resend_quote_for_client_approval===true) {
                msgStr = MSG_RESEND_QUOTE_FOR_CLIENT_APPROVAL;
                this.setToasterStatePop(true,msgStr,true,false);
            }
            else {
                this.setToasterState(true,msgStr,true);
            }

            this.shiftRef.current.closeShiftModal();
            this.props.shiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift,applyFilter:1,filtersData:this.state.filtersData});
            if(this.state.isFilterOn) {
                let tmpShiftId = this.state.activeShiftId;
                this.setState({activeShiftId:0}, () => {
                    this.setState({activeShiftId:tmpShiftId}); 
                })
            }
        }else if(activity===types.EVENT_SHIFT_UPDATE_ERROR){
            if(errorData.availability && errorData.staffs) {
                // ERROR IS DUE TO SHIFT TIME CHANGE WHILE SOME STAFF ACCEPTED THE SHIFT REQUEST 
                // SHOW THE STAFF UNAVAILABILITY POPUP 
            }
            else{
                let errMsg = MSG_SHIFT_UPDATE_ERROR;
                if(errorData.error && errorData.error==='past_time') errMsg = MSG_SHIFT_UPDATE_PAST_TIME_ERROR;
                this.setToasterState(true,errMsg,false); // JSON.stringify(errorData)
            }
            
        }else if(activity===types.SHIFT_LIST_SUCCESS && hrefShiftId !== undefined){
            if(this.state.hrefShiftIdUsed===0) {
                this.setState({hrefShiftIdUsed:1}, () => { this.showShiftDetail(hrefShiftId); }); 
            }
        }else if(activity===types.SHIFT_CANCEL_SUCCESS){
            this.props.shiftListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchShift,applyFilter:1,filtersData:this.state.filtersData});         
            this.setToasterState(true,MSG_SHIFT_CANCELLED,true); 
            this.closeDetailSlider();
        }else if(activity===types.SHIFT_CANCEL_ERROR){
            // {status: 'failed', message: 'shift_cannot_be_cancelled', shift_status: 'Completed'}
            let cancelErrMsg = MSG_SHIFT_CANCEL_ERROR; 
            if(errorData?.message && errorData.message==SHIFT_CANCEL_ERROR_CODE && errorData?.shift_status) { 
                // "Shift cancellation failed, The shift is already invoiced."
                cancelErrMsg = 'The shift is already '+errorData.shift_status+', '+MSG_SHIFT_CANCEL_ERROR; 
            }
            this.setToasterState(true, cancelErrMsg, false);
        }
             
    } 

    componentDidUpdate(prevProps) {
        const {isFilterOn,numRows,totalPage,activity,errorData,status,shiftPopupId,subactivity} = this.props;    

        if (shiftPopupId !== prevProps.shiftPopupId && shiftPopupId && Number(shiftPopupId) > 0) {
            this.showShiftDetail(shiftPopupId); 
            this.props.shiftPopupIdResetAction(''); 
        }

        if (isFilterOn !== prevProps.isFilterOn) {
            this.inputFilter.click();   
        }else if (activity !== prevProps.activity) {
            this.setStateUpdate(numRows,totalPage,activity,errorData,status);
            this.props.clearAction();
        }

        if (subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~');
            let actString = arrResp[0];
            if (actString === types.SHIFT_TIME_CHANGE_REQUEST_SUCCESS) {
                this.callToaster(true, MSG_SHIFT_TIME_CHANGE_ACCEPT_SUCCESS, true);
            }
        }
    }

    refreshPage = ()=>{
      window.location.reload();
    }

    componentDidMount() {
        const { location } = this.props;
        this.props.aflt_departmentsListAction({associated:'1'})
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
            this.setState({isClientPage:false});
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            this.setState({isClientPage:true});
            document.body.classList.add('body-client'); 
        }
        document.title = LBL_APP_NAME+" - "+LBL_SHIFTS;
        let applyFilterClicked = 0; 
        if(this.props.unallocatedShifts){
          let {filtersData} = this.state;
          filtersData['unallocatedShift']=true;
          filtersData['includeDate']=true;
          this.props.serverTimeAction();
          this.setState({applyFilter:1,filtersData:filtersData, isFilterOn:false, applyFilterClicked:applyFilterClicked,actionNeeded:true},()=>{
            this.props.serverTimeAction();
          }); 
        }else{
          let {filtersData} = this.state;
          filtersData['unallocatedShift']=true;
          filtersData['filtersSelected']=true;
          this.setState({applyFilter:1,filtersData:filtersData,isFilterOn:false, applyFilterClicked:applyFilterClicked,actionNeeded:true},()=>{
            this.props.serverTimeAction();
          });
         
        }
        
    }  

     onTimeFilterToggle = (flag) =>{
      let {actionNeeded} = this.state;
      actionNeeded = flag;
      
      this.setState({actionNeeded}, () => { 
        if(!actionNeeded)
          this.onResetFiltersButton()
        else{
            let {filtersData,applyFilterClicked} = this.state;
            filtersData['unallocatedShift']=true;
            filtersData['filtersSelected']=true;

            this.setState({applyFilter:1,filtersData:filtersData,isFilterOn:false, applyFilterClicked:applyFilterClicked,actionNeeded:true},()=>{
              this.props.serverTimeAction();
            });
        }
      });
   }
   
    render(){

      const {
         activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,shiftStatus,actionNeeded,sortField,sortOrder,          
     } = this.state  

      const { shiftsList,totalPage,status} = this.props;   
      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = ''; 
      let supervisor_name = ''; 
      let login_as_sa_user = 0;
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group;
         supervisor_name = userGroupData.supervisor_name+'(s)' 
         login_as_sa_user = userGroupData.login_as_sa_user; 
      }
      if(!supervisor_name){
            supervisor_name = LBL_CREW_CHIEF_S;
        }
    if(status===401 || status===403){
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }else{
            return <Redirect to={ROUTE_REFRESH} />;
        }
    }      

    let timeZone = getUserTimeZone(this.props.location);
    let isAddEvent = checkPermissions("events","modify");
    let isAddShift = checkPermissions("shifts","modify");
    let isViewSchedule = checkPermissions("schedule","view");
    let isClientView = checkPermissions("client","view");

    return(
         <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />


               <div className="box">
                  <div className="box-head">
                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder={LBL_SHIFT_NAME+'/'+LBL_EVENT_TITLE} id="my-search-input" onChange={this.onSearchShift} /></label>
                     </div>
                     {/* className="filter-btn-wrapper" */}
                     <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_FILTER}
                          </Tooltip>}
                        > 
                           <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                           
                        </OverlayTrigger>  
                    </div>     
                        {this.state.applyFilter > 0 && 
                        <div className="padding-left-20 padding-top-10 text-12 div150"  ><Link to="#" onClick={this.onResetFiltersButton} >{LBL_CLEAR_FILTERS}</Link></div> }                          
                    {/*<div className="to-right">
                      <Link onClick={(e) => this.refreshPage(e)} title="reload" className="btn btn-outline-primary reloadLink"><i className="las la-redo-alt"></i> </Link>
                    </div>*/}
                    <div className="btn-group btn-group-sm to-right toggle-view padding-right-15">
                          <OverlayTrigger
                              placement="top"
                              delay={{ show: 450, hide: 250 }}
                              overlay={<Tooltip id="list-tooltip" style={{
                                  opacity: 0.4,
                                }}>
                              {LBL_ACTION_NEEDED}
                          </Tooltip>}
                          > 
                              <Link className={actionNeeded===true?'btn btn-outline-primary active':'btn btn-outline-primary'} to="#" onClick={(e) =>this.onTimeFilterToggle(true)}>
                              <i className="las la-hand-pointer"></i> </Link>
                          </OverlayTrigger>
                          <OverlayTrigger
                              placement="top"
                              delay={{ show: 450, hide: 250 }}
                              overlay={<Tooltip id="calendar-tooltip" style={{
                                  opacity: 0.4,
                                }}>
                              {LBL_LIST_ALL} 
                          </Tooltip>}
                          >
                              <Link className={actionNeeded === false?'btn btn-outline-primary active':'btn btn-outline-primary'} to="#" onClick={(e) =>this.onTimeFilterToggle(false)}>
                              <i className="las la-list-alt"></i>  </Link>
                          </OverlayTrigger>
                     </div> 
                  </div>
                  
                  <div className="box-content">
                     <div className="table-responsive">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                                <tr>                                 
                                    <th>{LBL_SLNUM}</th>  
                                    <th className="max-width-15"></th>
                                    {/* <th onClick={(e) => this.onSort(e,'created_on')} className="state sorting_asc">Date</th>                             */}
                                    <th onClick={(e) => this.onSort(e,'title')} className="last-login-date spanPointer">{LBL_SHIFT_NAME} <i className={sortField=='title' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th onClick={(e) => this.onSort(e,'event__title')} className="last-login-date spanPointer">{LBL_EVENT_TITLE} <i className={sortField=='event__title' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th onClick={(e) => this.onSort(e,'start_datetime')} className="last-login-date spanPointer">{LBL_SHIFT_TIME} <i className={sortField=='start_datetime' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th >{supervisor_name}</th>
                                    <th onClick={(e) => this.onSort(e,'event__client_profile__company_name')} className="spanPointer">{LBL_CLIENT} <i className={sortField=='event__client_profile__company_name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th onClick={(e) => this.onSort(e,'status')} className="created-date spanPointer min-width-125 text-center">{LBL_SHIFT_STATUS} <i className={sortField=='status' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th onClick={(e) => this.onSort(e,'resources')} className="quote spanPointer text-center">{LBL_TEAM_COUNT} <i className={sortField=='resources' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>                                    
                                    {isViewSchedule && login_as_sa_user===0 && <th>{LBL_SCHEDULE}</th>}
                                    <th className="action">&nbsp;</th>
                                </tr>   
                           </thead> 
                           <tbody> 
                           {(this.props.count===0)  && 
                                    <tr>
                                        <td colSpan="13" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                            }
                           { shiftsList.map((item, index)  => {
                              let indeNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1;
                              const filteredStatus = shiftStatus.filter(x => Number(x.statusCode) ===Number(item.status));
                                let eventRoute = eventRouteRedirect(item.event_details.status);
                                let showShiftDelete = showShiftDeleteBtn(item.status);
                                let shiftNotCancelled = checkShiftNotCancelled(item.status);
                                let showShiftCancel   = showShiftCancelBtn(item.status);
                                let showShiftSchedule = showShiftScheduleBtn(item.status);

                                let eventStartDate = converDateToLocal(item.event_details.start_date,"+00:00",'ddmmyyyy'); 
                                let eventEndDate = converDateToLocal(item.event_details.end_date,"+00:00",'ddmmyyyy'); 

                                let prevStartDateTime = ''; 
                                let prevEndDateTime = ''; 
                                if(item.time_change_count>0) {
                                    prevStartDateTime = converDateToLocal(item.previous_start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');
                                    prevEndDateTime = converDateToLocal(item.previous_end_datetime,timeZone.utc_offset,'hhmm');
                                }  

                                let start_datetime = converDateToLocal(item.start_datetime,timeZone.utc_offset,'hhmm');
                                let end_datetime = converDateToLocal(item.end_datetime,timeZone.utc_offset,'hhmm');                                
                                let shiftStartDate = converDateToLocal(item.start_datetime,timeZone.utc_offset,'dayddmmyyyy'); 

                                let shiftEndDate = converDateToLocal(item.end_datetime,timeZone.utc_offset,'ddmmyyyy'); 
                                //let disableShiftEdit = shiftEditDisable(item.status);
                                
                                let crewChiefs  = item.crew_chiefs.reduce((acc, curr) => `${acc}${curr.chief_name}`+', ' ,'')
                                if(crewChiefs.length) crewChiefs = crewChiefs.substring(0,crewChiefs.lastIndexOf(",")); 

                                    let shiftLength = convertDecimalToHHMM(item.shift_length); 
                                    return (
                                        <tr key={index}>                           
                                            <td>{indeNum}</td> 
                                            <td className="max-width-15"><span className="change-count color-red text-bold ">{item.special_shift?"! ":""}</span><p> </p><p> </p></td>                                    
                                            <td><Link to="#" onClick={(e) => this.showShiftDetail(item.id)}>{item.title} </Link>
                                            {item.department_details && item.department_details.id && item.department_details.name && <div><small>{item.department_details.name}</small></div>}
                                            </td>
                                            <td>
                                                <Link to="#" onClick={(e) => this.showEventPage(item.event,eventRoute)} className={Number(item.total_assigned_crews) >= Number(item.resources)?'text-bold':''} >{item.event_details.title}</Link>
                                                <p className="m-0">
                                                    <small>{eventStartDate} - {eventEndDate}</small>
                                                </p>
                                            </td>
                                            <td>                                      
                                                {item.time_change_count>0 && 
                                                    <p className="text-danger mb-0"><small><s>{prevStartDateTime} - {prevEndDateTime}</s></small>{item.time_change_count>1  && <span className="change-count">({item.time_change_count})</span>}</p>
                                                }
                                             
                                                {start_datetime}-{end_datetime} ({shiftLength+' '+LBL_HOURS_SHORT.toLowerCase()})
                                         
                                                <p className="m-0">  <small>  
                                                    {shiftStartDate} -  {shiftEndDate}
                                                    </small>
                                                </p>
                                                </td>
                                            <td>{crewChiefs?crewChiefs:'No '+supervisor_name}</td>
                                            {isClientView && <td><Link to={ROUTE_AFFILIATE_CLIENT_PROFILE+'/'+item.event_details.client_profile}>{item.event_details.client_profile_details.company_name}</Link></td>}
                                            {!isClientView && <td>{item.event_details.client_profile_details.company_name}</td>}
                                            <td className={filteredStatus[0].colorClass+' text-center'}><small className="status-fill">{filteredStatus[0].statusString}</small></td>
                                            <td className="text-center">
                                                {item.total_assigned_crews}/{item.resources}
                                                {item.request_send_count > 0 &&
                                                  <p className="m-0">
                                                      <small>{item.request_send_count} {LBL_REQUESTS_SEND}</small>
                                                  </p>
                                                }
                                            </td> 
                                            {isViewSchedule && login_as_sa_user===0 &&  
                                             <td>
                                                {shiftNotCancelled && showShiftSchedule && 
                                                    <Link onClick={(e) => this.gotoSchedule(e, item.event,item)} to="#"><i className="lar la-clock pl-3" style={{"fontSize": "24px"}}></i></Link>
                                                }
                                             </td>
                                              }
                                             <td>
                                             {shiftNotCancelled && isAddEvent &&
                                             <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>                                                      
                                                       
                                                    <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                    
                                                      {showShiftDelete &&
                                                        <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.title)}>{LBL_DELETE}</Link>
                                                    }

                                                    { showShiftCancel &&
                                                        <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.openShiftCancelModal(item.id)}>{LBL_CANCEL}</Link>
                                                    }
                                                </div>
                                            </div>
                                            }
                                            </td>
                                        </tr>             
                                        
                                     )
                                   })      

                                }                      
                           </tbody> 
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>                    
               </div>

               <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
               {LBL_CONFIRM_DELETE_SHIFT+' '+this.state.shiftTitle+"' ?"}
               </ModalWindow>     
               <ModalWindow ref={this.modalShiftCancel} header="Confirm Cancel Shift" type="confirm" deleteConfirmedItem={this.onCancelAction} resetModalForm={this.onModalFormReset} >
               {LBL_CONFIRM_CANCEL_SHIFT}
               </ModalWindow>       

            </div>  
            <Filter isDetail={true} onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton}>
                <FilterShift filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters}  unallocatedShift={this.state.filtersData.unallocatedShift}/>
                {/* <ShiftDetailSlider activeShiftDetails={this.state.activeShiftDetails} toastFlag={this.state.shiftSummaryToastFlag} toastMessage={this.state.shiftSummaryToastMessage} toastSuccess={this.state.shiftSummaryToastSuccess} location={this.props.location} activeShiftSkillCrewData={this.state.activeShiftSkillCrewData} getShiftSkillCrewData={this.getShiftSkillCrewData} {...this.state} /> */}
                <ShiftDetailSlider location={this.props.location} activeShiftId={this.state.activeShiftId} editBtnClick={this.editBtnClick} deleteBtnClick={this.deleteBtnClick} loadEventSchedule={this.loadEventSchedule} calledFrom='ShiftList' openShiftCancelModal={this.openShiftCancelModal} />
            </Filter>

            <ShiftAdd 
                ref={this.shiftRef} 
                onsearchLocation={this.onSearchLocation} 
                {...this.state} 
                openAddClientContact={this.openAddClientContact} 
                shiftListsPage='shiftListsPage' 
                scheduleShift={this.scheduleShift}
            /> 

            <ModalWindow modalId="contactModalPop" ref={this.contactModal} header={LBL_ADD_NEW_CLIENT_CONTACT} saveFormData={ (e)=>this.onSaveFormClientContactData(e)} resetModalForm={this.onModalClientContactFormReset} type="save" >
                <ClientContactAdd saveFormDataClicked={this.state.saveFormDataClicked} newClientContactAdded={this.state.newClientContactAdded} refreshParent={this.refreshParent} clientId={this.state.eventDataForShift.clientId} setToasterStatePop={this.setToasterStatePop} addContactClicked={this.state.addContactClicked} ></ClientContactAdd>
            </ModalWindow>

         </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        shiftsList : state.event.shiftsList,
        totalPage:state.event.totalPage,
        status:state.event.status,
        activity:state.event.activity,
        subactivity: state.event.subactivity,
        numRows:state.event.numRows,
        count:state.event.count,
        errorData:state.event.errorData,
        shiftSliderDetails: state.event.shiftSliderDetails,
        shiftSliderStatus: state.event.shiftSliderStatus,
        shiftSliderActivity: state.event.shiftSliderActivity,  
        shiftSliderErrorData: state.event.shiftSliderErrorData,
        isFilterOn: state.commons.isFilterOn,
        shiftSkillCrewData: state.event.shiftSkillCrewData,                 
        shiftSkillCrewStatus: state.event.shiftSkillCrewStatus,      
        shiftSkillCrewActivity: state.event.shiftSkillCrewActivity,       
        shiftSkillCrewErrorData: state.event.shiftSkillCrewErrorData, 
        shiftPopupId:state.event.shiftPopupId,     
        unallocatedShifts:state.commons.fromDashboard,
        shiftUpdateData:state.event.shiftUpdateData    
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        shiftListAction:shiftListAction,
        quoteEventLocationListAction:quoteEventLocationListAction,
        shiftDeleteAction:shiftDeleteAction, 
        sendShiftIdsForScheduleAction:sendShiftIdsForScheduleAction,
        shiftCancelAction:shiftCancelAction,
        shiftPopupIdResetAction:shiftPopupIdResetAction,
        eventPopupIdSetAction:eventPopupIdSetAction, 
        menuActiveAction:menuActiveAction, 
        clearAction:clearAction,
        fromDashboard:fromDashboard,
        filterByAction:filterByAction,
        shiftTitle:shiftTitle,
        aflt_departmentsListAction:aflt_departmentsListAction,
        serverTimeAction:serverTimeAction
    },dispatch); 
}
export default connect(mapStateToProps,mapDispatchToProps)(ShiftListComponent);